"use strict";

exports.__esModule = true;
var _CreateDashboardWizard = require("./CreateDashboardWizard");
Object.keys(_CreateDashboardWizard).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CreateDashboardWizard[key]) return;
  exports[key] = _CreateDashboardWizard[key];
});